import { gql } from "@apollo/client";
import { RealtimeInvoiceOverviewType } from "../types/RealtimeInvoiceType";

export const GET_REALTIME_INVOICE_OVERVIEW = gql`
    query GetRealtimeInvoiceOverview($settlementClientId: ID!) {
        getRealtimeInvoiceOverview(settlementClientId: $settlementClientId) {
            settlementClientId
            totalRemainingAmount
            totalInvoicedAmount
            currency
            channelId
            customerName
            corporateEntityTitle
            netDay
        }
    }
`;

export interface GetRealtimeInvoiceOverviewResponse {
    getRealtimeInvoiceOverview: RealtimeInvoiceOverviewType;
}
